export default __webpack_public_path__ + "static/media/person1.6336d958.png";